import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  textInput: {
    margin: '10px auto',
    width: '90%',
  },
  recaptchaContainer: {
    display: 'flex', width: '100%', justifyContent: 'center',
  },
}));

export const styles = {
  boxContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    marginBlock: 2,
    minWidth: {
      xs: '100%', md: '350px', lg: '400px',
    },
  },
};

export default useStyles;
